module.exports = new __parcel__URL__("bison.4fe77735.svg").toString();